export const prefix = 'EBook_MODULE_'
// 公开命令
export default {
  /**
   * 初始化
   */
  INIT: prefix + 'INIT',
  /**
   * tab索引变化
   */
  TAB_INDEX_CHANGE: prefix + 'TAB_INDEX_CHANGE',
  /**
   * 头部高度变化
   */
  HEADER_HEIGHT_CHANGE: prefix + 'HEADER_HEIGHT_CHANGE',
  /**
   * 视频路径
   */
  VIDEO_PATH: prefix + 'VIDEO_PATH'
}



// WEBPACK FOOTER //
// ./src/store/command.js